import React, { Component } from 'react';
import { Grid, Row, Col, Panel, Button } from 'react-bootstrap';
import { Field } from 'redux-form'
import { Link } from 'react-router';
import ContentWrapper from '../Layout/ContentWrapper';
import Header from '../Layout/Header';
import { Translate, Localize } from 'react-redux-i18n';
import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';

const isGV = ROOT_API_URL === 'https://gvyummy-scm.truckxi.com/api/' || ROOT_URL === 'https://scm.gvyummy.com/api/';
const isCNT = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';

class Login extends Component {

    // When the form submitted, signup the user with username and password.

    handleFormSubmit({username, password}) {
        this.props.signinUser({ username, password });
    }

    // Error dealing

    renderAlert() {
        if (this.props.errorMessage) {
            return (
                <div className="alert alert-danger">
                    <strong><Translate value="oops" />!</strong> {this.props.errorMessage}
                </div>
            )
        }
    }

    render() {
        const { handleSubmit, pristine, reset, submitting } = this.props;
        return (
          <ContentWrapper>
            <div id="loginPanel">
              <div className="block-center wd-xxl">
                <div className="panel panel-dark panel-flat">
                  <div className="panel-heading text-center">
                    <a href="#">
                        {(!isGV && !isCNT) && <img src="img/logo.png" alt="Image" className="block-center img-rounded" />}
                        {isCNT && <p style={{color:'white', fontSize:'26px', marginBottom:'0px'}}>Chinatown Wholesale</p>}
                    </a>
                  </div>
                  <div className="panel-body">
                    <p className="text-center pv"><Translate value="sign_in_to_continue"/></p>
                    <form className="mb-lg" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                      <div className="form-group has-feedback">
                        <label><Translate value="username" /></label>
                          <Field className="largeInput" name="username" component="input" id="exampleInputusername1" type="username" placeholder="Username" autoComplete="off" required="required" className="form-control" />
                          <span className="fa fa-envelope form-control-feedback text-muted"></span>
                      </div>
                      <div className="form-group has-feedback">
                          <label><Translate value="password" /></label>
                          <Field className="largeInput" name="password" component="input" id="exampleInputPassword1" type="password" placeholder="Password" required="required" className="form-control" />
                          <span className="fa fa-lock form-control-feedback text-muted"></span>
                      </div>
                      <div className="form-group">
                          <label>
                              <input type="checkbox" value="" name="remember" />
                              <Translate value="remember_me"/>
                          </label>
                      </div>
                      {this.renderAlert() }
                      <button type="submit" className="btn btn-block btn-success mt-lg"><Translate value="login" defaultMessage="Login" description="Login"/></button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </ContentWrapper>
        );
    }

}

export default Login;



// WEBPACK FOOTER //
// ./master/jsx/components/Auth/login.jsx